exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".textarea{resize:none;height:35px;width:100%;border:1px solid #919191}", ""]);

// exports
